import { apiClient } from './apiClient';

export interface PowerIrradianceData {
  timestamp: string;
  power_kw: number;
  irradiance_wm2: number;
}

export interface PowerIrradianceResponse {
  data: PowerIrradianceData[];
  correlation_coefficient: number;
  last_updated: string;
}

export interface DailyExportData {
  date: string;
  total_export_kwh: number;
  total_energy_kwh: number;
  export_efficiency: number;
}

export interface DailyExportResponse {
  data: DailyExportData[];
  period: string;
  last_updated: string;
}

export interface TechnicalSummary {
  current_power_kw: number;
  current_irradiance_wm2: number;
  today_energy_kwh: number;
  performance_ratio: number;
  last_updated: string;
}

export const technicalApi = {
  // Get live power vs irradiance data
  getPowerIrradianceData: async (hours: number = 24): Promise<PowerIrradianceResponse> => {
    const response = await apiClient.get(`/api/monitoring/technical/power-irradiance/?hours=${hours}`);
    return response.data;
  },

  // Get daily export trends
  getDailyExportTrends: async (days: number = 7): Promise<DailyExportResponse> => {
    const response = await apiClient.get(`/api/monitoring/technical/daily-export/?days=${days}`);
    return response.data;
  },

  // Get technical dashboard summary
  getTechnicalSummary: async (): Promise<TechnicalSummary> => {
    const response = await apiClient.get('/api/monitoring/technical/summary/');
    return response.data;
  }
};